module.exports = __webpack_public_path__ + "static/media/Team 25 - Smart Farmers.0c368639.png";